export default "__VITE_ASSET__BRTvrduD__"